




import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class ImageLink extends Vue {
  @Prop() selfWindow?: boolean;
  @Prop() src!: string;
  @Prop() alt?: string;
  @Prop() link!: string;

  get linkTarget() {
    return this.selfWindow ? '_self' : '_blank';
  }
}
